/**
 * @deprecated
 */
export enum Sizes {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}
/**
 * @deprecated
 */
export enum IconSizes {
  XS = 10,
  SM = 14,
  MD = 18,
  LG = 22,
  XL = 26,
  XXL = 30,
  XXXL = 34,
  VXL = 42,
  VXXL = 50,
  VVXL = 64,
  VVVXL = 84,
}

/**
 * @deprecated Use CustomColorsRef instead
 */
export enum CustomColors {
  Primary = 'imovPrimary',
  PrimaryLight = 'imovPrimaryLight',
  PrimaryDark = 'imovPrimaryDark',
  Secondary = 'imovSecondary',
  SecondaryLight = 'imovSecondaryLight',
  SecondaryDark = 'imovSecondaryDark',
  White = 'imovWhite',
  WhiteShadow = 'imovWhiteShadow',
  Gray = 'imovGray',
  GrayDark = 'imovGrayDark',
  Danger = 'imovDanger',
  DangerDark = 'imovDangerDark',
  Warning = 'imovWarning',
  WarningDark = 'imovWarningDark',
  Success = 'imovSuccess',
  SuccessDark = 'imovSuccessDark',
}
/**
 * @deprecated
 */
export enum CustomColorsRef {
  Primary = '#2563eb',
  PrimaryLight = '#3b82f6',
  Secondary = '#1d004e',
  PrimaryDark = '#1d4ed8',
  SecondaryLight = '#4d359b',
  SecondaryDark = '#0f0031',
  White = '#fefffe',
  WhiteShadow = '#ebebeb',
  Gray = '#d1d1d1',
  GrayDark = '#a9a9a9',
  Danger = '#dc3545',
  DangerDark = '#c82333',
  Warning = '#ffc107',
  WarningDark = '#e0a800',
  Success = '#198754',
  SuccessDark = '#157347',
}
/**
 * @deprecated
 */
export enum UploadStatus {
  Uploading = 'uploading',
  Success = 'success',
  Error = 'error',
  Idle = 'idle',
}
/**
 * @deprecated
 */
export interface FieldChangeEventAnswer {
  name: string
  type: string
  value: string
}

export interface Filters {
  bedrooms: string[]
  bathrooms: string[]
  unitType: string[]
  location: {
    zip_code: string
    full_address: string
    range: number
    city?: string
    /** @deprecated use neighborhoods */
    neighborhood?: string
    neighborhoods?: string[]
  }
  tags: string[]
  booleans: { [key: string]: boolean }
  price: string[]
  priceMin?: number
  priceMax?: number
  contractEnd: { startDate: string, endDate: string }
  availability: { startDate: string, endDate: string }
}